module.exports = __webpack_public_path__ + "img/342.cbde1aa4.jpg";